import type scriptZh from '../zh/script';

const script: typeof scriptZh = {
  saved: 'Đã lưu mẫu tin',
  created: 'Đã tạo mẫu tin',
  col_updated: 'Cập nhật',
  col_created: 'Tạo',
  actions: 'Thao tác',
  title: 'Mẫu tin',
  detail_title: 'Chi tiết mẫu tin',
  detail_load_failed: 'Không tải được chi tiết mẫu tin',
  detail_empty: 'Chưa có chi tiết mẫu tin',
  variables: 'Biến',
  load_failed: 'Không tải được danh sách mẫu tin',
  shop_required: 'Vui lòng chọn cửa hàng trước',
  create_failed: 'Không tạo được mẫu tin',
  update_failed: 'Không lưu được mẫu tin',
  delete_failed: 'Không xóa được mẫu tin',
  delete_success: 'Đã xóa mẫu tin',
  delete_confirm: 'Xóa mẫu tin “{{name}}”? Thao tác này không thể hoàn tác.',
  new_template: 'Tạo mẫu mới',
  ds_generate: 'Tạo bằng DS',
  generated_name: 'Tạo bằng DS · {{point}}',
  generated: 'Đã tạo. Xác nhận để lưu thành mẫu',
  channel_dm: 'Tin nhắn',
  channel_email: 'Email',
  name_required: 'Vui lòng nhập tên mẫu tin',
  content_required: 'Vui lòng nhập nội dung mẫu tin',
  edit_title: 'Sửa mẫu tin',
  new_title: 'Tạo mẫu tin',
  name: 'Tên',
  name_placeholder: 'VD: Dùng thử sản phẩm mới · Làm đẹp',
  channel: 'Kênh',
  subject: 'Chủ đề',
  subject_placeholder: 'Chủ đề email, có thể bỏ trống',
  body: 'Nội dung',
  body_placeholder: 'Hi {{token}}, chúng tôi có sản phẩm mới phù hợp với fan của bạn…',
  points_required: 'Vui lòng nhập gợi ý nội dung',
  generate_failed: 'Tạo thất bại, vui lòng thử lại sau',
  generate_title: 'Tạo mẫu tin',
  generate: 'Tạo',
  name_hint: 'Gợi ý tên',
  name_hint_placeholder: 'VD: Dùng thử sản phẩm mới · Làm đẹp',
  selling_points: 'Gợi ý nội dung',
  points_placeholder: 'Lời mời dùng thử mỹ phẩm, giọng thân thiện và ngắn'
};

export default script;
